import { render, staticRenderFns } from "./AddOpeningLand.vue?vue&type=template&id=cc81d696"
import script from "./AddOpeningLand.vue?vue&type=script&lang=js"
export * from "./AddOpeningLand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports